import { Cancel, Save } from '@mui/icons-material';
import { Divider, Grid, MenuItem, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import CustomButton, {
  CustomSelect,
  CustomTextField,
} from '../../../../Common/Components/Controls/InputControls';
import { capitalizeWords } from '../../../../Helpers/UtilityMethods';
import { Product, Subscription } from '../../../Common/CommonModel';
import { commonService } from '../../../Common/CommonService';
import {
  CardWrapper,
  FooterContainer,
  FooterWrapper,
  PaperWrapper,
} from '../../Common/CommonComponents';
import StorageAccountConstants from '../Common/Constants';
import { StorageAccount } from '../Model/StorageAccountModel';
import { CreateOrEditProps, ParamProps } from '../Model/StorageAccountProps';
import { storageAccountService } from '../StorageAccountService';
import { Loader } from '../../../../Common/Components/Loader';
import { showToast } from '../../../../lib/toast';

const StorageAccountFarm: React.FC<CreateOrEditProps> = ({
  storageAccount,
  setStorageAccount,
  AddOrEditStorageAccount,
  showOperationbutton,
  showBackbutton,
  operation,
}) => {
  const [AzureRegions, setRegions] = useState<string[]>([]);
  const [Products, setProducts] = useState<Product[]>([]);
  const [Subscriptions, setSuscriptions] = useState<Subscription[]>([]);
  const [loading, setloading] = useState(true);

  useEffect(() => {
    InitData();
  }, []);

  const InitData = async () => {
    setloading(true);
    await loadAzureRegions().catch((err) => console.log(err));
    await loadProducts().catch((err) => console.log(err));
    await loadSubscriptions().catch((err) => console.log(err));
    setloading(false);
  };
  const loadAzureRegions = async () => {
    const azureRegions = await commonService.getAzureRegions();
    setRegions(azureRegions);
  };

  const loadSubscriptions = async () => {
    const subscriptions = await commonService.getSubscriptions();
    setSuscriptions(subscriptions.Items);
  };

  const loadProducts = async () => {
    const products = await commonService.getProducts();
    setProducts(products.Items);
  };

  return (
    <>
      {loading ? (
        <Loader loading={loading} />
      ) : (
        <>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <CardWrapper>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                  {operation.charAt(0).toUpperCase() + operation.slice(1)}{' '}
                  Storage Account
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      Storage Account Name
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomTextField
                      disabled={operation !== 'create'}
                      value={storageAccount.Name}
                      onChange={(e) =>
                        setStorageAccount({
                          ...storageAccount,
                          Name: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Resource Group</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomTextField
                      value={storageAccount.ResourceGroup}
                      onChange={(e) =>
                        setStorageAccount({
                          ...storageAccount,
                          ResourceGroup: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Product Id</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomSelect
                      value={storageAccount.ProductID}
                      onChange={(e) =>
                        setStorageAccount({
                          ...storageAccount,
                          ProductID: e.target.value,
                        })
                      }
                    >
                      {Products.map((product) => (
                        <MenuItem key={product.Id} value={product.Id}>
                          {product.Id}
                        </MenuItem>
                      ))}
                    </CustomSelect>
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Subscription</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomSelect
                      value={storageAccount.Subscription}
                      onChange={(e) =>
                        setStorageAccount({
                          ...storageAccount,
                          Subscription: e.target.value,
                        })
                      }
                    >
                      {Subscriptions.map((subscription) => (
                        <MenuItem
                          key={subscription.Name}
                          value={subscription.Name}
                        >
                          {subscription.Name}
                        </MenuItem>
                      ))}
                    </CustomSelect>
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Azure Region</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomSelect
                      value={storageAccount.AzureRegion}
                      onChange={(e) =>
                        setStorageAccount({
                          ...storageAccount,
                          AzureRegion: e.target.value,
                        })
                      }
                    >
                      {AzureRegions.map((region) => (
                        <MenuItem key={region} value={region}>
                          {region}
                        </MenuItem>
                      ))}
                    </CustomSelect>
                  </Grid>
                </Grid>
              </CardWrapper>
            </Grid>
          </Grid>
          <FooterWrapper>
            <FooterContainer>
              <Grid item xs={12} sm="auto">
                {showOperationbutton(AddOrEditStorageAccount)}
              </Grid>
              <Grid item xs={12} sm="auto">
                {showBackbutton()}
              </Grid>
            </FooterContainer>
          </FooterWrapper>
        </>
      )}
    </>
  );
};

export default function StorageAccountOps() {
  const [storageAccount, setStorageAccount] = useState<StorageAccount>({
    Name: '',
    ProductID: '',
    ResourceGroup: '',
    Subscription: '',
    Purpose: 'Archive',
    tStorageKey: 0,
    AzureRegion: '',
  });
  const history = useHistory();

  const param = useParams<ParamProps>();
  const Operation = param.Operation.toLocaleLowerCase();

  useEffect(() => {
    if (Operation === 'edit') {
      GetStorageAccount();
    }
  }, []);

  const validateStorageAccount = (storageAccount: StorageAccount) => {
    if (
      storageAccount.Name.trim() === '' ||
      storageAccount.AzureRegion.trim() === '' ||
      storageAccount.ProductID.trim() === '' ||
      storageAccount.Subscription.trim() === '' ||
      storageAccount.ResourceGroup.trim() === ''
    ) {
      showToast({
        type: 'error',
        title: 'all field are mandatory',
      });
      return false;
    }
    return true;
  };
  const handleCancel = async () => {
    history.push('/storageaccount');
  };

  const AddOrEditStorageAccount = async () => {
    if (validateStorageAccount(storageAccount)) {
      try {
        await storageAccountService.setstorageAccount(storageAccount);
        handleCancel();
        showToast({
          title: StorageAccountConstants.StorageAccountSaveSuc,
          type: 'success',
        });
      } catch (error) {
        console.log(error);
        showToast({
          type: 'error',
          title: (error as Error).message,
        });
      }
    }
  };

  const GetStorageAccount = async () => {
    try {
      await storageAccountService
        .getstorageAccount(param.Name)
        .then((storageAccount) => setStorageAccount(storageAccount));
    } catch {
      showToast({
        type: 'error',
        title: StorageAccountConstants.StorageAccountSaveFailed,
      });
    }
  };

  const showBackOption = () => {
    return (
      <CustomButton
        startIcon={<Cancel />}
        onClick={handleCancel}
        label="Cancel"
      />
    );
  };

  const showOpsOption = (
    handleOperation: React.MouseEventHandler<HTMLButtonElement>,
  ) => {
    return (
      <CustomButton
        startIcon={<Save />}
        onClick={handleOperation}
        label="Save"
      />
    );
  };

  return (
    <div>
      <PaperWrapper>
        <Typography variant="h5" sx={{ mb: 2 }}>
          {capitalizeWords(Operation)} Storage Account
        </Typography>
        <Divider sx={{ mb: 3 }} />
        <StorageAccountFarm
          storageAccount={storageAccount}
          setStorageAccount={setStorageAccount}
          AddOrEditStorageAccount={AddOrEditStorageAccount}
          showOperationbutton={showOpsOption}
          showBackbutton={showBackOption}
          operation={Operation}
        />
      </PaperWrapper>
    </div>
  );
}
